export default "__VITE_ASSET__826ed13b__"